import { ReactNode } from "react";

import { Card } from "design_system_radar/card";
import { RadarLogo } from "design_system_radar/icons/RadarLogo";

interface AuthSplitLayoutProps {
  children: ReactNode;
  description?: ReactNode;
  notice?: ReactNode;
  title: string;
  titleMeta?: ReactNode;
}

const AuthSplitLayout = ({
  children,
  description,
  notice,
  title,
  titleMeta,
}: AuthSplitLayoutProps) => {
  return (
    <main
      className="flex min-h-screen flex-col justify-center bg-[#171821] px-5 py-7 text-white sm:px-8 sm:py-10 lg:px-14 lg:py-12"
      role="main"
    >
      <div className="mx-auto w-full max-w-7xl">
        <div className="grid gap-8 lg:grid-cols-2 lg:items-center">
          <div className="flex flex-col items-center justify-center">
            <div className="w-full max-w-90">
              <h2 className="text-[28px] font-semibold tracking-[-0.03em] text-white">
                {title}
              </h2>

              {titleMeta ? (
                <div className="mt-4">{titleMeta}</div>
              ) : description ? (
                <div className="mt-4 text-[14px] leading-6 text-white/72">
                  {description}
                </div>
              ) : null}

              {notice ? <div className="mt-7">{notice}</div> : null}

              <div className="mt-16">{children}</div>
            </div>
          </div>

          <div className="flex items-center justify-center">
            <Card className="relative h-200 w-full max-w-184 overflow-hidden rounded-[12px] border-0 bg-white">
              <picture>
                <source srcSet="/radar-bg.avif" type="image/avif" />
                <source srcSet="/radar-bg.webp" type="image/webp" />
                <img
                  src="/radar-bg.png"
                  alt=""
                  aria-hidden="true"
                  className="absolute inset-0 h-full w-full object-cover"
                  fetchPriority="high"
                  height={1632}
                  loading="eager"
                  width={2912}
                />
              </picture>
              <div className="absolute inset-x-0 top-1/2 flex -translate-y-1/2 justify-center px-8">
                <RadarLogo
                  size={400}
                  fill="#fff"
                  stroke="rgba(0, 0, 0, 0.85)"
                  strokeWidth={2}
                  className="h-auto w-full max-w-100"
                  aria-label="Radar"
                />
              </div>
            </Card>
          </div>
        </div>
      </div>
    </main>
  );
};

export default AuthSplitLayout;
